import { PaymentTaskExpenseAccountItemCreateForm } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskExpenseAccountItemEditForm/PaymentTaskExpenseAccountItemCreateForm';
import { PaymentTaskExpenseAccountItemsElement } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskExpenseAccountItemEditForm/PaymentTaskExpenseAccountItemsElement';
import { useExpenseAccountItems } from '@/hooks/api/2340_expense_account_items';
import { usePaymentTaskExpenseAccountItems } from '@/hooks/api/2350_payment_task_expense_account_items';
import { PaymentTaskLogic } from '@/hooks/api/models/logics';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

export const PaymentTaskExpenseAccountItemEditForm = () => {
  const navigate = useNavigate();
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  const { data: expenseAccountItems } = useExpenseAccountItems();
  const { data: paymentTaskExpenseAccountItems } = usePaymentTaskExpenseAccountItems({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    purchase_order_id: Number(purchase_order_id),
    task_id: task!.id,
  });

  useEffect(() => {
    if (task!.payment_amount == null) navigate(-1);
  }, []);

  if (expenseAccountItems == null || paymentTaskExpenseAccountItems == null) return <></>;

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <div className="col-12 col-lg-9 mx-auto">
          <div className="card mb-4" id="basic-info">
            <div className="card-header d-flex align-items-center">
              <div className="col-md-8">
                <h5 className="mb-1">費用科目の分類</h5>
                <p className="text-xs mb-0">請求金額を各費用科目に分類してください。</p>
              </div>
            </div>
            <div className="card-body pt-0 row">
              <div className="form-group">
                <label>タスク名</label>
                <p className="form-text text-muted text-sm ms-1">{task!.name}</p>
              </div>
              <div className="d-flex justify-content-end">
                <div className="table-responsive">
                  <table className="table align-items-center">
                    <thead>
                      <tr>
                        <th
                          className="text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end"
                          style={{ width: 150 }}
                        >
                          投入金額合計
                        </th>
                        <th
                          className="text-secondary text-xxs font-weight-bold opacity-7 px-2 text-end"
                          style={{ width: 150 }}
                        >
                          未分類金額合計
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-end text-dark text-xs">
                          ¥
                          {PaymentTaskLogic.categorizedExpenseAccountItemAmount(
                            task!,
                            paymentTaskExpenseAccountItems
                          ).toLocaleString()}
                        </td>
                        <td className="text-end text-dark text-xs">
                          ¥
                          {PaymentTaskLogic.unCategorizedExpenseAccountItemAmount(
                            task!,
                            paymentTaskExpenseAccountItems
                          ).toLocaleString()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <hr className="horizontal dark my-3" />

              <PaymentTaskExpenseAccountItemCreateForm
                expenseAccountItems={expenseAccountItems}
                paymentTaskExpenseAccountItems={paymentTaskExpenseAccountItems}
              />

              <hr className="horizontal dark my-3" />

              <PaymentTaskExpenseAccountItemsElement paymentTaskExpenseAccountItems={paymentTaskExpenseAccountItems} />
            </div>
            <div className="card-footer d-flex align-items-center justify-content-end pt-0">
              <Link to="" className="btn btn-outline-secondary" onClick={() => navigate(-1)}>
                支払タスク詳細へ
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
